import { trigger, style, animate, transition, state } from '@angular/animations';

export const opacityFadeIn = (speed: number = 300, id: string = '') => trigger(
  `opacityFadeIn${id}`, 
  [
    state(
      'void',
      style({ opacity: 0 })
    ),
    state(
      '*',
      style({ opacity: 1 })
    ),
    transition(
      'void => *', 
      [
        animate(`${speed}ms ease-out`)
      ]
    )
  ]
);
